import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { ApiEndpoint } from '../enums/api-endpoints.enum';

export interface SiteMapPage {
  page_id: number;
  title: string;
  link: string;
  subpages: SiteMapPage[];
  parent_page_id: number;
  active?: boolean;
}

export type SiteMap = SiteMapPage[];

@Injectable({ providedIn: 'root' })
export class SitemapService {
  private siteMapCache$: Observable<SiteMap>;

  constructor(private http: HttpClient) {}

  public get siteMap$(): Observable<SiteMap> {
    if (!this.siteMapCache$) {
      this.siteMapCache$ = this.http.get<SiteMap>(ApiEndpoint.CENTURION_SITE_MAP).pipe(shareReplay(1));
    }

    return this.siteMapCache$;
  }

  public getPageId(url: string): Observable<number> {
    const [urlWithoutFragment] = url.split('#');

    return this.siteMap$.pipe(
      map((siteMap) => {
        const page = this.getPageByUrl(siteMap, urlWithoutFragment);

        return page ? page.page_id : null;
      })
    );
  }

  private getPageByUrl(siteMap: SiteMap, url: string): SiteMapPage {
    const stack = [siteMap[0]];
    let page: SiteMapPage;

    while (stack.length) {
      page = stack.pop();

      if (page.link === url) {
        return page;
      } else if (page.subpages && page.subpages.length) {
        stack.push(...page.subpages);
      }
    }
  }
}
